import api from "./apiClient.js";

const endpoint = "whattodo";

export const getAllWhatToDos = () => {
	return api.get(endpoint);
};

export const getAllWhatToDosShort = () => {
	return api.get(endpoint + "/icons");
};

export const getWhatToDoById = (id) => {
	return api.get(endpoint + "/" + id);
};

export const createWhatToDo = (whatToDo) => {
	return api.post(endpoint, whatToDo);
};

export const updateWhatToDo = (whatToDo) => {
	return api.put(endpoint + "/" + whatToDo.id, whatToDo);
};

export const deleteWhatToDo = (id) => {
	return api.delete(endpoint + "/" + id);
};
